import { render } from "./switcher.vue?vue&type=template&id=3b08219c&ts=true"
import script from "./switcher.vue?vue&type=script&lang=ts"
export * from "./switcher.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__